<mat-card class="large-card" [ngStyle]="cardListContainerStyle" [ngClass]="cardId">
    <card-controller-panel [cardInfo]="cardControllerInfo"></card-controller-panel>
    <div class="card-list">
        <div class="title-area">
            <div
                class="card-title"
                (click)="clickTitle()"
                [ngStyle]="{
                    cursor: cardListData.isTitleClickable ? 'pointer' : 'default'
                }"
            >
                {{ cardTitle }}
            </div>
            <div
                *ngIf="cardListData.hasData && !cardListData.hideViewAll"
                class="card-view-all"
                (click)="clickViewAll($event)"
            >
                View All
            </div>
        </div>
        <div
            *ngIf="cardListData.hasData && cardListData.dataTableData && cardListData.isDataReady"
            class="cardlist-table-data-area"
            id="cardlist-table-data-area"
        >
            <table width="100%" class="cardlist-table">
                <tr>
                    <td>
                        <table width="100%">
                            <tr
                                id="{{ 'cardlist-table-header-tr' + cardId }}"
                                class="cardlist-table-header-tr"
                            >
                                <th
                                    *ngFor="let thItem of cardListData.dataTableData[0].tdList"
                                    [ngStyle]="thItem.headerStyle"
                                >
                                    {{ thItem.headerTitle }}
                                </th>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td id="{{ 'cardlist-data-area-inner-td' + cardId }}">
                        <div
                            class="cardlist-table-body-area"
                            [ngStyle]="innerTableStyles"
                            id="{{ 'cardlist-table-body-area' + cardId }}"
                        >
                            <table width="100%" class="cardlist-data-table">
                                <tr
                                    *ngFor="let rowData of cardListData.dataTableData"
                                    class="cardlist-data-tr {{ 'cardlist-data-tr' + cardId }} "
                                >
                                    <td
                                        class="table-data-td"
                                        [ngStyle]="tdItem.style"
                                        *ngFor="let tdItem of rowData.tdList"
                                    >
                                        <div class="cardlist-data-cell">
                                            <div
                                                *ngIf="tdItem.tooltipText"
                                                class="tooltip-container"
                                            >
                                                <span class="cardlist-tooltiptext">
                                                    {{ tdItem.tooltipText }}
                                                </span>
                                            </div>
                                            <div *ngIf="tdItem.isIconColumn" class="icon-area">
                                                <mat-icon
                                                    class="{{ tdItem.iconClass }}"
                                                    aria-hidden="true"
                                                >
                                                </mat-icon>
                                            </div>
                                            <div
                                                *ngIf="
                                                    tdItem.showIndicator &&
                                                    !tdItem.isIconColumn &&
                                                    !cardListData.showPercentages
                                                "
                                                class="cardlist-data-cell-icon-left"
                                            >
                                                <div
                                                    style="display: inline-block"
                                                    [innerHTML]="tdItem.svgData"
                                                ></div>
                                            </div>
                                            <div
                                                class="{{
                                                    tdItem.hasAccess
                                                        ? 'cardlist-hyperlinked-value'
                                                        : ''
                                                }} cardlist-data-cell-value"
                                                *ngIf="tdItem.isHyperlinked && !tdItem.isIconColumn"
                                                (click)="clickTableCardItem(tdItem)"
                                            >
                                                {{ tdItem.value }}
                                            </div>
                                            <div
                                                class="cardlist-data-cell-value"
                                                *ngIf="
                                                    !tdItem.isHyperlinked && !tdItem.isIconColumn
                                                "
                                                [ngStyle]="{
                                                    color: tdItem.indicatorColor
                                                }"
                                            >
                                                <div *ngIf="!cardListData.showPercentages">
                                                    {{ tdItem.value }}
                                                </div>
                                                <!--TODO: move this logic to .ts; move styles to .scss-->
                                                <div *ngIf="cardListData.showPercentages">
                                                    <span
                                                        [ngStyle]="{
                                                            width:
                                                                tdItem.value.length > 8
                                                                    ? '89px'
                                                                    : '58px'
                                                        }"
                                                        style="display: inline-block"
                                                        >{{ tdItem.value }}
                                                    </span>
                                                    <span
                                                        *ngIf="
                                                            tdItem.percent || tdItem.percent === 0
                                                        "
                                                        style="padding-left: 5px"
                                                        >/
                                                    </span>
                                                    <span
                                                        *ngIf="
                                                            tdItem.percent || tdItem.percent === 0
                                                        "
                                                        style="
                                                            display: inline-block;
                                                            width: 29px;
                                                            text-align: right;
                                                        "
                                                        >{{ tdItem.percent }}%</span
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="card-list-spinner-area" *ngIf="!cardListData.isDataReady">
        <spin-loader [type]="'spinner'"></spin-loader>
    </div>

    <div class="no-data-message-area" *ngIf="!cardListData.hasData && cardListData.isDataReady">
        <no-data-screen [noDataType]="noDataType"> </no-data-screen>
    </div>
</mat-card>
